import { Text } from '@heathmont/moon-components';
import { rem } from '@heathmont/moon-utils';
import Translate from '~/client/shared/i18n/Translate';
import InlineStack from '~/client/shared/InlineStack';

const MinimumAgeLimitText = () => (
  <InlineStack padding="0px 12px 0px" marginTop={rem(-8)}>
    <Text size={12} color="trunks.100">
      <Translate id="profile.signup.age_over_18" />
    </Text>
  </InlineStack>
);

export default MinimumAgeLimitText;
